import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Alaska = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Alaska Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Nine-page form with checklist covering various property features
          must be provided before an offer.
        </Text>

        <Text style={styles.listItem}>
          2. Disclosure Statement: Sellers must provide a Real Estate Transfer
          Disclosure Statement.
        </Text>

        <Text style={styles.listItem}>
          3. Inspection Contingency: Commonly included due to extreme weather
          conditions.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Per federal law, this document must be given to all buyers if the
          residence was constructed prior to 1978.
        </Text>

        <Text style={styles.listItem}>
          6. <Text style={styles.underline}>Property Disclosure Form</Text> –
          Also known as Form 08-4229. The seller must provide this form prior to
          agreeing to an offer.
        </Text>

        <Text style={styles.listItem}>
          7.{' '}
          <Text style={styles.underline}>
            Real Estate Commission Consumer Pamphlet
          </Text>{' '}
          – Required if a real estate agent is working with one of the parties.
        </Text>
      </View>
    </View>
  );
};

export default Alaska;
